export default "__VITE_ASSET__C_Ymi60___"